import React from 'react'
import { Flex } from 'antd'

function Title(props) {
    return (
        <Flex justify="center" style={{ fontSize: 20, marginBottom: 16, fontWeight: 'bold', position: 'relative', textAlign: 'center', padding: '0 8px' }}>
            {props.name}
        </Flex>
    )
}

export default Title
